"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleSetPurchase = exports.createGatewaySaga = void 0;
const effects_1 = require("redux-saga/effects");
const redux_persistence_1 = require("redux-persistence");
const Network_1 = require("decentraland-ui/dist/components/BuyManaWithFiatModal/Network");
const eth_1 = require("../../lib/eth");
const actions_1 = require("../gateway/actions");
const actions_2 = require("../modal/actions");
const utils_1 = require("../transaction/utils");
const selectors_1 = require("../wallet/selectors");
const actions_3 = require("../wallet/actions");
const actions_4 = require("./actions");
const moonpay_1 = require("./moonpay");
const types_1 = require("./moonpay/types");
const selectors_2 = require("./selectors");
const transak_1 = require("./transak");
const types_2 = require("./types");
const utils_2 = require("./utils");
const DEFAULT_POLLING_DELAY = 3000;
const BUY_MANA_WITH_FIAT_FEEDBACK_MODAL_NAME = 'BuyManaWithFiatFeedbackModal';
function createGatewaySaga(config) {
    return function* gatewaySaga() {
        yield (0, effects_1.takeEvery)(actions_4.OPEN_BUY_MANA_WITH_FIAT_MODAL_REQUEST, handleOpenBuyManaWithFiatModal, config);
        yield (0, effects_1.takeEvery)(actions_4.OPEN_MANA_FIAT_GATEWAY_REQUEST, handleOpenFiatGateway, config);
        yield (0, effects_1.takeEvery)(actions_4.MANA_FIAT_GATEWAY_PURCHASE_COMPLETED, handleFiatGatewayPurchaseCompleted, config);
        yield (0, effects_1.takeEvery)(actions_1.SET_PURCHASE, handleSetPurchase);
        yield (0, effects_1.takeLatest)(redux_persistence_1.LOAD, handleStorageLoad);
        yield (0, effects_1.takeEvery)(actions_1.POLL_PURCHASE_STATUS_REQUEST, handlePollPurchaseStatusRequest, config);
        yield (0, effects_1.takeEvery)(utils_2.purchaseEventsChannel, handlePurchaseChannelEvent);
        function* handlePurchaseChannelEvent(action) {
            const { purchase } = action;
            yield (0, effects_1.put)((0, actions_1.setPurchase)(purchase));
        }
    };
}
exports.createGatewaySaga = createGatewaySaga;
function* handleOpenBuyManaWithFiatModal(config, action) {
    try {
        const { selectedNetwork } = action.payload;
        const pendingManaPurchase = yield (0, effects_1.select)(selectors_2.getPendingManaPurchase);
        if (pendingManaPurchase) {
            let goToUrl;
            if (pendingManaPurchase.gateway === Network_1.NetworkGatewayType.MOON_PAY) {
                goToUrl = new moonpay_1.MoonPay(config.moonPay).getTransactionReceiptUrl(pendingManaPurchase.id);
            }
            yield (0, effects_1.put)((0, actions_2.openModal)(BUY_MANA_WITH_FIAT_FEEDBACK_MODAL_NAME, {
                purchase: pendingManaPurchase,
                goToUrl
            }));
        }
        else {
            yield (0, effects_1.put)((0, actions_2.openModal)('BuyManaWithFiatModal', { selectedNetwork }));
        }
        yield (0, effects_1.put)((0, actions_4.openBuyManaWithFiatModalSuccess)());
    }
    catch (error) {
        yield (0, effects_1.put)((0, actions_4.openBuyManaWithFiatModalFailure)(error.message));
    }
}
function* handleOpenFiatGateway(config, action) {
    const { network, gateway } = action.payload;
    const { transak: transakConfig, moonPay: moonPayConfig } = config;
    try {
        switch (gateway) {
            case Network_1.NetworkGatewayType.TRANSAK:
                const address = yield (0, effects_1.select)(selectors_1.getAddress);
                const customizationOptions = {
                    defaultCryptoCurrency: 'MANA',
                    cyptoCurrencyList: 'MANA',
                    fiatCurrency: '',
                    email: '',
                    redirectURL: ''
                };
                const transak = new transak_1.Transak(transakConfig, customizationOptions);
                transak.openWidget(address, network);
                break;
            case Network_1.NetworkGatewayType.MOON_PAY:
                const moonPay = new moonpay_1.MoonPay(moonPayConfig);
                const widgetUrl = moonPay.getWidgetUrl(network);
                window.open(widgetUrl, '_blank', 'noopener,noreferrer');
                break;
            default:
                break;
        }
        yield (0, effects_1.put)((0, actions_4.openManaFiatGatewaySuccess)());
    }
    catch (error) {
        yield (0, effects_1.put)((0, actions_4.openManaFiatGatewayFailure)(network, gateway, error.message));
    }
}
function* upsertPurchase(moonPay, transaction, network) {
    let purchase = moonPay.createPurchase(transaction, network);
    yield (0, effects_1.put)((0, actions_1.setPurchase)(purchase));
}
function* handleStorageLoad() {
    const pendingPurchases = yield (0, effects_1.select)(selectors_2.getPendingPurchases);
    if (pendingPurchases) {
        for (const pendingPurchase of pendingPurchases) {
            const { network, gateway, id } = pendingPurchase;
            switch (gateway) {
                case Network_1.NetworkGatewayType.TRANSAK:
                    yield (0, effects_1.put)((0, actions_1.pollPurchaseStatusRequest)(pendingPurchase));
                    break;
                case Network_1.NetworkGatewayType.MOON_PAY:
                    yield (0, effects_1.put)((0, actions_4.manaFiatGatewayPurchaseCompleted)(network, gateway, id, types_1.MoonPayTransactionStatus.PENDING));
                    break;
            }
        }
    }
}
function* handlePollPurchaseStatusRequest(config, action) {
    const { purchase } = action.payload;
    const { gateway, id } = purchase;
    try {
        if (purchase.status !== types_2.PurchaseStatus.PENDING) {
            yield (0, effects_1.put)((0, actions_1.pollPurchaseStatusSuccess)());
            return;
        }
        switch (gateway) {
            case Network_1.NetworkGatewayType.TRANSAK:
                const { transak: transakConfig } = config;
                const transak = new transak_1.Transak(transakConfig);
                let statusHasChanged = false;
                while (!statusHasChanged) {
                    const { data: { status, transactionHash, errorMessage } } = yield (0, effects_1.call)([transak, transak.getOrder], id);
                    const newStatus = yield (0, effects_1.call)([transak, transak.getPurchaseStatus], status);
                    if (newStatus !== purchase.status) {
                        statusHasChanged = true;
                        yield (0, effects_1.put)((0, actions_1.setPurchase)(Object.assign(Object.assign({}, purchase), { status: newStatus, txHash: transactionHash || null, failureReason: errorMessage })));
                        continue;
                    }
                    yield (0, effects_1.delay)(transakConfig.pollingDelay || DEFAULT_POLLING_DELAY);
                }
                break;
            default:
                break;
        }
        yield (0, effects_1.put)((0, actions_1.pollPurchaseStatusSuccess)());
    }
    catch (error) {
        yield (0, effects_1.put)((0, actions_1.pollPurchaseStatusFailure)(error.message));
    }
}
function* handleFiatGatewayPurchaseCompleted(config, action) {
    const { network, gateway, transactionId, status } = action.payload;
    try {
        switch (gateway) {
            case Network_1.NetworkGatewayType.MOON_PAY:
                const { moonPay: moonPayConfig } = config;
                const finalStatuses = [
                    types_1.MoonPayTransactionStatus.COMPLETED,
                    types_1.MoonPayTransactionStatus.FAILED
                ];
                const moonPay = new moonpay_1.MoonPay(moonPayConfig);
                let statusHasChanged = false;
                let transaction = yield (0, effects_1.call)([moonPay, moonPay.getTransaction], transactionId);
                if (!finalStatuses.includes(transaction.status)) {
                    yield (0, effects_1.put)((0, actions_2.openModal)(BUY_MANA_WITH_FIAT_FEEDBACK_MODAL_NAME, {
                        purchase: moonPay.createPurchase(transaction, network),
                        goToUrl: moonPay.getTransactionReceiptUrl(transactionId)
                    }));
                }
                yield (0, effects_1.call)(upsertPurchase, moonPay, transaction, network);
                while (!statusHasChanged) {
                    const { status: newStatus } = transaction;
                    if (newStatus !== status || finalStatuses.includes(newStatus)) {
                        statusHasChanged = true;
                        yield (0, effects_1.call)(upsertPurchase, moonPay, transaction, network);
                        continue;
                    }
                    yield (0, effects_1.delay)(moonPayConfig.pollingDelay || DEFAULT_POLLING_DELAY);
                    transaction = yield (0, effects_1.call)([moonPay, moonPay.getTransaction], transactionId);
                }
            default:
                break;
        }
    }
    catch (error) {
        yield (0, effects_1.put)((0, actions_4.manaFiatGatewayPurchaseCompletedFailure)(network, gateway, transactionId, error.message));
    }
}
function* handleSetManaPurchase(purchase) {
    const finalStatuses = [
        types_2.PurchaseStatus.COMPLETE,
        types_2.PurchaseStatus.REFUNDED,
        types_2.PurchaseStatus.FAILED,
        types_2.PurchaseStatus.CANCELLED
    ];
    const { status, network, txHash } = purchase;
    if (finalStatuses.includes(status)) {
        let transactionUrl;
        if (status === types_2.PurchaseStatus.COMPLETE) {
            yield (0, effects_1.put)((0, actions_3.fetchWalletRequest)());
            if (txHash) {
                const chainId = yield (0, effects_1.call)(eth_1.getChainIdByNetwork, network);
                transactionUrl = (0, utils_1.getTransactionHref)({ txHash }, chainId);
            }
        }
        if (txHash) {
            yield (0, effects_1.put)((0, actions_4.addManaPurchaseAsTransaction)(purchase));
        }
        yield (0, effects_1.put)((0, actions_2.openModal)(BUY_MANA_WITH_FIAT_FEEDBACK_MODAL_NAME, {
            purchase,
            transactionUrl
        }));
    }
}
function* handleSetPurchase(action) {
    const { purchase } = action.payload;
    if ((0, utils_2.isManaPurchase)(purchase)) {
        yield (0, effects_1.call)(handleSetManaPurchase, purchase);
    }
}
exports.handleSetPurchase = handleSetPurchase;
//# sourceMappingURL=sagas.js.map